import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'

import registrationModule from './modules/registrationModule'
import headerModule from './modules/headerModule'
import dashboardModule from './modules/dashboardModule'
import alertModule from './modules/alertModule'
import customerModule from './modules/customerModule'
import addpacksModule from './modules/productModule/addpacksModule'
import packsModule from './modules/productModule/packsModule'
import renewModule from './modules/productModule/renewModule'
import modifyModule from './modules/productModule/modifyModule'
import bulkModule from './modules/productModule/bulkModule'
import deviceModule from './modules/deviceModule'
import reportModule from './modules/reportModule'
import downloadModule from './modules/downloadModule'
import cartSubscribeModule from './modules/cartSubscribeModule'

const serverType =  'PROD'
export const store = new Vuex.Store({
    state: {
        name: 'NXTDigital LCO Portal',
        version: 'v1.0.6',
        mode: "production",
        baseUrl: getAPIUrl(),
        firebaseUrl: 'https://imcl-lco-35e48.firebaseio.com',
        userInfo: undefined,
        subuserInfo: undefined,
        SubscriberDetails: undefined,
        getCartDetails: {},
        pageNameProduct: '',
        AutoRenewItem: {},
        getCustomerNumber: undefined,
        getCheckoutDetails: {},
        getSideNavInfoDetails: '',
        ReportQueueing: {},
        invoiceCartDetails: {},
        sideNav: true,
        customerEnteredId: '',
        uniqueCustomerId: '',
        showAllModule: '',
        ottVerifiedUsers: {},
        changeBasePack: {},
        changeValidity: {},
        SMSTemplates: [
            {smsid:'SMS1',
                content:'Dear Subscriber, Your NXTDigital TV subscription is due to expire in next 5 days. Please contact your local cable operator OR call us on 1800 210 0300 to avoid service disruption',
                displayText:'Expiry in 5 days'},
            {smsid:'SMS2',
                content:'Dear Subscriber, Your NXTDigital TV subscription is due to expire in next 3 days. Please contact your local cable operator OR call us on 1800 210 0300 to avoid service disruption',
                displayText:'Expiry in 3 days'},
            {smsid:'SMS3',
                content:'Dear Subscriber, Your NXTDigital TV subscription is due to expire TOMORROW. Please contact your local cable operator OR call us on 1800 210 0300 to avoid service disruption',
                displayText:'Expiring tomorrow'},
            {smsid:'SMS4',
                content:'Dear Subscriber, Your NXTDigital TV subscription HAS EXPIRED. Please contact your local cable operator OR call us on 1800 210 0300 to RENEW',
                displayText:'Expired'}
        ],
        verifiedBroadbandCustomer: false,
        sitekey:  captchaSiteKey(serverType) ? '6LfVCHYoAAAAALYgugUK5noScAmzDzugh2_LnItm' : '6Lf0DHYoAAAAADWhvp559CdGFYVyddD_ifbD-tG3',
        cryptoSecretKey: 'CBCSHAAES256',
        cryptoIVKey: 'CBCSHAAES256VECTOR',
        whatsappURL: 'https://api.whatsapp.com/send?phone=919004815767&&text=Hello',
        uniqueNewCustomerId: '',
        renewTypeDashboard: '',
    },
    getters,
    mutations,
    actions,
    modules: {
        registrationModule,
        headerModule,
        dashboardModule,
        alertModule,
        customerModule,
        addpacksModule,
        packsModule,
        renewModule,
        modifyModule,
        bulkModule,
        deviceModule,
        reportModule,
        downloadModule,
        cartSubscribeModule
    }
})
function captchaSiteKey (data) {
    console.log(data)
    if (data == 'UAT') {
        return true
    }
    return false
}
function getAPIUrl () {
    const isLocalhost = window.location.origin.includes('localhost');
    return isLocalhost 
    //   ? 'https://lcoportalbeta.mobiotics.com/' 
      ? 'https://lcoportalnew7.nxtdigital.in/'
      : window.location.origin + '/';
  };


// WEBPACK FOOTER //
// ./src/store/store.js